import { images } from '.';
 
const services = [  
    {   
        id: 1, 
        image: images.service1, 
        title: '⼤全聯量販發票折抵⾃動歸⼾',
        content: '在賣場購物付款後，您的消費紀錄將會直接與停車場系統整合，您不需要再過繳費機。',
        paragraphs: [
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore repudiandae aut eum rem praesentium doloremque quos perferendis ipsa sed placeat fugiat minima tenetur facilis, similique, esse molestias harum. Illo, obcaecati?',
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.',
        ],
        gallery: [ 
            images.service1Gallery1,
            images.service1Gallery2,
        ],
        benefits: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.'
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat.'
            ],
            workItems: {
                planning: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                design: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                construct: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            },
        },
        faqs: [
            { 
                id: 1, 
                heading: 'How do we charge for projects?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            }, 
            { 
                id: 2,
                heading: 'Do we offer free in-person estimates?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 3, 
                heading: 'What is our service area?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 4,
                heading: 'do we hire subcontractors?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
        ]
    },
    {
        id: 2,
        image: images.service2,
        title: '商店美食街折抵',
        content: '您如果在大全聯賣場內店家進行消費，同樣享有折抵服務。消費完成的同時店家直接將折扣綁定到您的愛車。',
        icon: 'star',
        paragraphs: [
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore repudiandae aut eum rem praesentium doloremque quos perferendis ipsa sed placeat fugiat minima tenetur facilis, similique, esse molestias harum. Illo, obcaecati?',
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.',
        ],
        gallery: [ 
            images.service2Gallery1,
            images.service2Gallery2,
        ],
        benefits: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.'
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat.'
            ],
            workItems: {
                planning: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                design: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                construct: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            },
        },
        faqs: [
            { 
                id: 1, 
                heading: 'How do we charge for projects?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            }, 
            { 
                id: 2,
                heading: 'Do we offer free in-person estimates?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 3, 
                heading: 'What is our service area?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 4,
                heading: 'do we hire subcontractors?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
        ]
    },
    {
        id: 3,
        image: images.service3,
        title: '直接離場免等待',
        content: '只要有大全聯會員並完成支付綁定，直接享有VIP尊榮可直接離場，完全不需等待。離場後我們將直接統計您的折抵。',
        icon: 'headset',
        paragraphs: [
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore repudiandae aut eum rem praesentium doloremque quos perferendis ipsa sed placeat fugiat minima tenetur facilis, similique, esse molestias harum. Illo, obcaecati?',
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.',
        ],
        gallery: [ 
            images.service3Gallery1,
            images.service3Gallery2,
        ],
        benefits: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.'
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat.'
            ],
            workItems: {
                planning: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                design: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                construct: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            },
        },
        faqs: [
            { 
                id: 1, 
                heading: 'How do we charge for projects?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            }, 
            { 
                id: 2,
                heading: 'Do we offer free in-person estimates?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 3, 
                heading: 'What is our service area?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 4,
                heading: 'do we hire subcontractors?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
        ]
    },
    {
        id: 4,
        image: images.service4,
        title: '綁定繳費⽅式輕鬆付',
        content: '目前我們支援信用卡與Line Pay綁定服務。',
        icon: 'phone',
        paragraphs: [
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore repudiandae aut eum rem praesentium doloremque quos perferendis ipsa sed placeat fugiat minima tenetur facilis, similique, esse molestias harum. Illo, obcaecati?',
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.',
        ],
        gallery: [ 
            images.service4Gallery1,
            images.service4Gallery2,
        ],
        benefits: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.'
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat.'
            ],
            workItems: {
                planning: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                design: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                construct: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            },
        },
        faqs: [
            { 
                id: 1, 
                heading: 'How do we charge for projects?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            }, 
            { 
                id: 2,
                heading: 'Do we offer free in-person estimates?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 3, 
                heading: 'What is our service area?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 4,
                heading: 'do we hire subcontractors?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
        ]
    },
    {
        id: 5,
        image: images.service5,
        title: '隨時查詢停⾞費',
        content: '進入停車場後，您隨時可以透過我們的網頁服務查詢您的折抵時數與預估的停車費。',
        icon: 'calendar',
        paragraphs: [
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore repudiandae aut eum rem praesentium doloremque quos perferendis ipsa sed placeat fugiat minima tenetur facilis, similique, esse molestias harum. Illo, obcaecati?',
            'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.',
        ],
        gallery: [ 
            images.service5Gallery1,
            images.service5Gallery2,
        ],
        benefits: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.'
            ],
            list: [
                'Save You Time And Money',
                'Creates high aesthetic quality',
                'Maximize the space',
                'Adds a sense of functionality',
                'Increase the Value of your Home'
            ]
        },
        workFlow: {
            paragraphs: [
                'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat.'
            ],
            workItems: {
                planning: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                design: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
                construct: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
            },
        },
        faqs: [
            { 
                id: 1, 
                heading: 'How do we charge for projects?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            }, 
            { 
                id: 2,
                heading: 'Do we offer free in-person estimates?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 3, 
                heading: 'What is our service area?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
            {
                id: 4,
                heading: 'do we hire subcontractors?',
                content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
            },
        ]
     },
    // {
    //     id: 6,
    //     image: images.service6,
    //     title: 'Renovation',
    //     content: 'Lorem Ipsum Dolor Sit Amet Consectetur Adipisicing Elit. Consequatur Possimus Assumenda Dolores Odit.',
    //     icon: 'thumbsUp',
    //     paragraphs: [
    //         'Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore repudiandae aut eum rem praesentium doloremque quos perferendis ipsa sed placeat fugiat minima tenetur facilis, similique, esse molestias harum. Illo, obcaecati?',
    //         'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.',
    //     ],
    //     gallery: [ 
    //         images.service6Gallery1,
    //         images.service6Gallery2,
    //     ],
    //     benefits: {
    //         paragraphs: [
    //             'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat, maiores architecto debitis reiciendis odio impedit omnis distinctio ullam.'
    //         ],
    //         list: [
    //             'Save You Time And Money',
    //             'Creates high aesthetic quality',
    //             'Maximize the space',
    //             'Adds a sense of functionality',
    //             'Increase the Value of your Home'
    //         ]
    //     },
    //     workFlow: {
    //         paragraphs: [
    //             'Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto, vel facere iste nobis exercitationem dicta? Sapiente repellendus quis in sequi, repellat.'
    //         ],
    //         workItems: {
    //             planning: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    //             design: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    //             construct: 'Lorem ipsum dolor sit amet consectetur adipisicing elit.',
    //         },
    //     },
    //     faqs: [
    //         { 
    //             id: 1, 
    //             heading: 'How do we charge for projects?',
    //             content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
    //         }, 
    //         { 
    //             id: 2,
    //             heading: 'Do we offer free in-person estimates?',
    //             content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
    //         },
    //         {
    //             id: 3, 
    //             heading: 'What is our service area?',
    //             content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
    //         },
    //         {
    //             id: 4,
    //             heading: 'do we hire subcontractors?',
    //             content: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit. Minus, laboriosam non eligendi reiciendis quis laborum exercitationem voluptatibus autem harum nihil nisi sed mollitia, quam blanditiis architecto cumque? Sit, voluptate maiores.',
    //         },
    //     ]
    // },
 
];

export default services;